// src/components/other/SplashScreen.jsx
import React from "react";

const SplashScreen = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center bg-white">
      <img
        loading="lazy"
        src="/logo.png"
        alt="Loading..."
        className="h-16 animate-pulse"
      />
    </div>
  );
};

export default SplashScreen;
